import Header from '@components/head';
import Layout from '@/layout/Layout';
import BottomCta from '@/modules/home-page/components/bottom-cta';
import CanDo from '@/modules/home-page/components/can-do';
import Effect from '@/modules/home-page/components/effects';
import Faqs from '@/modules/home-page/components/faqs';
import HeroBanner from '@/modules/home-page/components/hero-banner';
import ImportCase from '@/modules/home-page/components/import-case';
import MediaPublic from '@/modules/home-page/components/media-public';
import PricingCom from '@/modules/home-page/components/pricing';
import SolveProblems from '@/modules/home-page/components/solve-problems';
import UsefulExample from '@/modules/home-page/components/useful-example';
import { graphql } from 'gatsby';
import React from 'react';
import * as styles from './index.module.less';
import HonorPart from '@/modules/home-page/components/honor-part';
import CommonBlok from '@/components/common-blok';
import { HONOR_LOGOS } from '@/constants';

export const HonorPartWrapper = ({ children }) => {
  return (
    <CommonBlok className={styles.honor_part} paddingBottom="0" paddingTop="0">
      {children}
    </CommonBlok>
  );
};

const HomePage = () => {
  return (
    <Layout isNewLayout>
      <Header
        cover="https://a.storyblok.com/f/159374/1801x946/1e59455742/open-graph-image-2.png"
        canonical="https://www.notta.ai/"
        htmlAttr={{ lang: 'ja' }}
        title="自動文字起こしサービス | Notta"
        description="Nottaは最新のAI音声認識エンジンを搭載する高精度な文字起こしサービスです。リアルタイム文字起こしと翻訳機能を備え、また、1度に最長5時間までの音声ファイルを素早くテキスト化が可能。PCで音声変換や編集も気軽に行います。"
      />
      {/* Hero Banner */}
      <HeroBanner />
      <HonorPartWrapper>
        <HonorPart
          honorLogos={HONOR_LOGOS}
          tips="※ 日本マーケティングリサーチ機構調べ    調査概要：2023年6月期 ブランドのイメージ調査"
          isShowTitle={false}
          honorImgClass={styles.honor_img}
        />
      </HonorPartWrapper>
      {/* 引入Notta的效果 */}
      <Effect isShowStatistics />
      {/* Notta解决的问题 */}
      <SolveProblems />
      {/* Notta can do */}
      <CanDo />
      {/* ほかの便利な機能例 */}
      <UsefulExample />
      {/* Pricing */}
      <PricingCom />
      {/* 导入事例 */}
      <ImportCase />
      {/* FAQs */}
      <Faqs />
      {/* メディア掲載実績 */}
      <MediaPublic />
      {/* bottom cta */}
      <BottomCta />
    </Layout>
  );
};

export default HomePage;

export const query = graphql`
  query ($language: String!) {
    locales: allLocale(filter: { language: { eq: $language } }) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
  }
`;
